





































import snackbar from '@/mixins/snackbar';
import mixins from '@/utils/mixins';
type FunctionInitializer<T> = T extends any ? T | (() => T) : never;

export default mixins(snackbar).extend({
  name: 'core-snack-bar',
  computed: {
    bind() {
      if (this.snackbar.btn.to) return { to: this.snackbar.btn.to };
      if (this.snackbar.btn.href) {
        return {
          href: this.snackbar.btn.href,
          target: '_blank',
          rel: 'noopener'
        };
      }
      return this.snackbar.btn;
    },
    computedColor() {
      if (this.snackbar.color !== 'store') {
        return !this.computedIcon ? 'primary lighten-3' : null;
      }
      return 'green';
    },

    useAction() {
      return !!this.snackbar.useBtn;
    }
  },
  watch: {
    $route() {
      this.snack = false;
    },
    snackbar() {
      if (this.snackbar.id) {
        if (localStorage.getItem(this.snackbar.id)) return;
      }

      this.snack = true;
    }
  },

  methods: {
    markViewed() {
      if (this.snackbar.id) {
        localStorage.setItem(this.snackbar.id, 'true');
      }
      this.snack = false;
    },

    runSnackbarAction<T>(arg: FunctionInitializer<T>): T {
      return typeof arg === 'function' ? arg() : arg; // arg is callable in the true branch
    },

    onClick() {
      this.markViewed();
      if (this.snackbar.action)
        return this.runSnackbarAction(this.snackbar.action);
    }
  }
});
